import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import localeText from "../../../../locale";
import ExtracoinService from "../../../../service/ExtracoinService";
import handleLocale from "../../../../utilities/LocaleSwitch";
import { formatPrice } from "../../../../utilities/formatPrice";
import { locale } from "../../../../utilities/locale/locale";
import EmailSecurityCodeField from "../../../../components/EmailSecurityCodeField/EmailSecurityCodeField";

const ExtracoinIntents = (props) => {
  const { currency } = props;

  const [loading, setLoading] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [intentsReceived, setIntentsReceived] = useState([]);
  const [intentsSent, setIntentsSent] = useState([]);
  const [confirmTransaction, setConfirmTransaction] = useState(false);
  const [transactionInfo, setTransactionInfo] = useState({});
  const [code, setCode] = useState("");

  const [activeIndex, setActiveIndex] = useState(0);

  const toast = useRef(null);

  const securityCodeRef = useRef(null);
  const codeRef = useRef(null);
  const [securityCode, setSecurityCode] = useState("");

  let localeISO = "en-US";

  localeISO = handleLocale(locale);

  const extracoinService = new ExtracoinService();

  async function acceptTransaction(transactionId, code) {
    try {
      securityCodeRef.current.style.border = "1px solid #ced4da";
      codeRef.current.style.border = "1px solid #ced4da";

      if (code.length === 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("codeCantBeEmpty"),
          life: 6000,
        });
        codeRef.current.style.border = "1px solid red";
        return;
      }
      if (securityCode.trim().length === 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("securityCodeCantBeEmpty"),
          life: 6000,
        });
        securityCodeRef.current.style.border = "1px solid red";
        return;
      }
      setLoadingAccept(true);

      const res = await extracoinService.postToAgree(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        transactionId,
        code,
        securityCode.trim()
      );
      if (res.messageCode === 500166) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("securityCodeIsWrong"),
          life: 6000,
        });
        setLoadingAccept(false);
      } else if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingAccept(false);
      } else {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("transactionReceived"),
          life: 6000,
        });

        const resReceived = await extracoinService.getIntentsTo(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );

        if (resReceived.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resReceived.messageCode).message,
            life: 6000,
          });
          setLoadingAccept(false);
          setConfirmTransaction(false);
        } else {
          setIntentsReceived(
            resReceived.result.filter((intent) => intent.agreementFrom && !intent.agreementTo)
          );
          setLoadingAccept(false);
          setConfirmTransaction(false);
        }
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoadingAccept(false);
      setConfirmTransaction(false);
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);

        const resReceived = await extracoinService.getIntentsTo(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        if (cancel) return;

        const resSent = await extracoinService.getIntentsFrom(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );

        if (resReceived.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resReceived.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setIntentsReceived(
            resReceived.result.filter((intent) => intent.agreementFrom && !intent.agreementTo)
          );
          setIntentsSent(resSent.result.filter((intent) => intent.agreementFrom));
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="card border-1 border-300">
        <Toast ref={toast} position="top-left" />

        <div className="flex flex-wrap justify-content-between align-items-center">
          <h3 className="my-4">{localeText("transferRequests")}</h3>
        </div>

        <hr />
        <Dialog
          header={
            <>
              <i className="pi pi-exclamation-triangle text-2xl pr-2"></i>
              <span className="font-bold m-0 p-0 text-2xl">
                {localeText("attention").toUpperCase()}:
              </span>{" "}
              {localeText("confirmYourAction")}
            </>
          }
          visible={confirmTransaction}
          className="w-30rem mx-2"
          onHide={() => {
            if (!loadingAccept) setConfirmTransaction(false);
          }}
          draggable={false}
        >
          <>
            <div className="mr-3 ml-3">
              {transactionInfo.taxTo && (
                <p>
                  {localeText("confirmTransactionExplanation")}{" "}
                  <b className="text-xl">
                    {currency} {formatPrice(transactionInfo.taxTo)}.
                  </b>
                </p>
              )}
              <p>{localeText("toAgreeAndReceiveInsertCode")}:</p>
              <InputText
                ref={codeRef}
                onChange={(e) => setCode(e.target.value)}
                onFocus={() => (codeRef.current.style.border = "1px solid #ced4da")}
                value={code}
              />
              <EmailSecurityCodeField
                ref={securityCodeRef}
                value={securityCode}
                onChange={setSecurityCode}
                onFocus={() => (securityCodeRef.current.style.border = "1px solid #ced4da")}
                disabled={loadingAccept}
              />
              <p className="mt-2">{localeText("doYouAgree")}</p>
              <div className="flex gap-2 justify-content-end">
                <Button
                  onClick={() => setConfirmTransaction(false)}
                  severity="danger"
                  disabled={loadingAccept}
                >
                  {localeText("no")}
                </Button>
                <Button
                  onClick={() => acceptTransaction(transactionInfo.id, code)}
                  disabled={loadingAccept}
                  className={`${loadingAccept ? "opacity-80" : ""}`}
                >
                  <div className="flex justify-content-center align-items-center gap-2">
                    {loadingAccept && <Loading classNameIcon={"text-sm"} disableMargin />}
                    <p>{localeText("yes")}</p>
                  </div>
                </Button>
              </div>
            </div>
          </>
        </Dialog>

        <div className="mt-4 mb-6">
          <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header={localeText("showingReceivedRequests")}>
              <DataTable
                value={intentsReceived}
                paginator
                responsiveLayout="scroll"
                loading={loading || loadingAccept}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate={localeText("showingFirstToLast")}
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
              >
                <Column
                  field="userFrom.username"
                  header={localeText("sender")}
                  style={{ width: "20%" }}
                />
                <Column
                  header={localeText("amount")}
                  style={{ width: "20%" }}
                  body={(intent) => {
                    return (
                      <>
                        {currency}{" "}
                        {intent.amountTo.toLocaleString(localeISO, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </>
                    );
                  }}
                />
                <Column
                  header="Tax"
                  style={{ width: "20%" }}
                  body={(intent) => {
                    return (
                      <>
                        {currency}{" "}
                        {intent.taxTo.toLocaleString(localeISO, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </>
                    );
                  }}
                />
                <Column
                  header={localeText("status")}
                  body={(intent) => {
                    return (
                      <>
                        {intent.agreementTo ? (
                          <span
                            className="team-member-role text-0 p-1 border-round"
                            style={{ backgroundColor: "#46a748" }}
                          >
                            {localeText("accepted").toUpperCase()}
                          </span>
                        ) : (
                          <span
                            className="team-member-role text-0 p-1 border-round"
                            style={{ backgroundColor: "#F7B005" }}
                          >
                            {localeText("pending").toUpperCase()}
                          </span>
                        )}
                      </>
                    );
                  }}
                  style={{ width: "20%" }}
                />
                <Column
                  header={<>{localeText("confirm")}?</>}
                  body={(intent) => {
                    return (
                      <>
                        {!intent.agreementTo ? (
                          <Button
                            icon="pi pi-check"
                            className="p-button-rounded"
                            onClick={() => {
                              setTransactionInfo(intent);
                              setConfirmTransaction(true);
                            }}
                          />
                        ) : (
                          <Link to="/extracoinstatement">
                            <p className="button-blank mobile-a">{localeText("seeStatement")}</p>
                          </Link>
                        )}
                      </>
                    );
                  }}
                  style={{ width: "20%" }}
                />
              </DataTable>
            </TabPanel>
            <TabPanel header={localeText("showingSentRequests")}>
              <DataTable
                value={intentsSent}
                paginator
                responsiveLayout="scroll"
                loading={loading || loadingAccept}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate={localeText("showingFirstToLast")}
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
              >
                <Column
                  field="userTo.username"
                  header={localeText("addressee")}
                  style={{ width: "20%" }}
                />
                <Column
                  header={localeText("amount")}
                  style={{ width: "20%" }}
                  body={(intent) => {
                    return (
                      <>
                        {currency}{" "}
                        {intent.amountFrom.toLocaleString(localeISO, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </>
                    );
                  }}
                />
                <Column
                  header="Tax"
                  style={{ width: "20%" }}
                  body={(intent) => {
                    return (
                      <>
                        {currency}{" "}
                        {intent.taxFrom.toLocaleString(localeISO, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </>
                    );
                  }}
                />
                <Column
                  header={localeText("status")}
                  body={(intent) => {
                    return (
                      <>
                        {intent.agreementTo ? (
                          <span
                            className="team-member-role text-0 p-1 border-round"
                            style={{ backgroundColor: "#46a748" }}
                          >
                            {localeText("accepted").toUpperCase()}
                          </span>
                        ) : (
                          <span
                            className="team-member-role text-0 p-1 border-round"
                            style={{ backgroundColor: "#F7B005" }}
                          >
                            {localeText("pending").toUpperCase()}
                          </span>
                        )}
                      </>
                    );
                  }}
                  style={{ width: "20%" }}
                />
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};

export default ExtracoinIntents;
